import _ from "lodash";
import BaseView from "scripts/views/baseView";
import templateFacetedSearchSummaryMenu from "templates/search/facetedSearchSummaryMenu.hbs";

class FacetedSearchSummaryMenuView extends BaseView {
  get template() {
    return templateFacetedSearchSummaryMenu;
  }

  get id() {
    return "bb-faceted-search-summary-menu";
  }

  get className() {
    return "faceted-search-summary-menu";
  }

  get events() {
    return {
      "click #bb-faceted-search-refine-button": "onClickRefineButton",
      "click #bb-faceted-search-grid-view-link": "onClickGridView",
      "click #bb-faceted-search-list-view-link": "onClickListView",
      "click #bb-faceted-search-chart-module-segment": "onClickModuleSegment",
      "click #bb-faceted-search-chart-anthology-segment":
        "onClickAnthologySegment",
      "click #bb-faceted-search-chart-collection-segment":
        "onClickCollectionSegment",
      "click #bb-faceted-search-chart-written-segment": "onClickWrittenSegment",
      "click #bb-faceted-search-chart-image-segment": "onClickImageSegment",
      "click #bb-faceted-search-chart-audio-segment": "onClickAudioSegment",
      "click #bb-faceted-search-chart-video-segment": "onClickVideoSegment",
    };
  }

  update() {
    this.render();
  }

  render() {
    this.destroyTooltips();

    this.$el.html(
      this.template(
        _.merge(
          {
            hasResults: this.collection.totalRecords > 0,
            totalRecords: _.numberFormat(this.collection.totalRecords),
            searchTime: _.numberFormat(this.collection.searchTime / 1000, 2),
            isListView: this.model.get("presentationType") === "list",
          },
          this.getSegmentWidths(),
        ),
      ),
    );

    this.initTooltips();
  }

  findCount(facetValues, code) {
    const info = facetValues.find(o => o.code === code);

    if (info) {
      return parseInt(info.count, 10);
    } else {
      return 0;
    }
  }

  getSegmentWidths() {
    const facets = this.collection.facets;

    const contentTypeValues = facets.contentType
      ? facets.contentType.facetValues
      : [];
    //const mediaTypeValues = facets.type ? facets.type.facetValues : [];
    //
    //const moduleCount = this.findCount(mediaTypeValues, 'MODULE');
    //const anthologyCount = this.findCount(mediaTypeValues, 'ANTHOLOGY');
    //const collectionCount = this.findCount(mediaTypeValues, 'COLLECTION');

    const writtenCount =
      this.findCount(contentTypeValues, "BOOK") +
      this.findCount(contentTypeValues, "ARTICLE") +
      this.findCount(contentTypeValues, "OTHER_DOCUMENT");

    const imageCount = this.findCount(contentTypeValues, "IMAGE");
    const audioCount = this.findCount(contentTypeValues, "AUDIO");
    const videoCount = this.findCount(contentTypeValues, "VIDEO");

    //const totalCount = moduleCount +
    //    anthologyCount +
    //    collectionCount +
    //    writtenCount +
    //    imageCount +
    //    audioCount +
    //    videoCount;

    const totalCount = writtenCount + imageCount + audioCount + videoCount;

    return {
      //moduleSegmentWidth: (moduleCount * 100) / totalCount,
      //anthologySegmentWidth: (anthologyCount * 100) / totalCount,
      //collectionSegmentWidth: (collectionCount * 100) / totalCount,
      writtenSegmentWidth: writtenCount * 100 / totalCount,
      imageSegmentWidth: imageCount * 100 / totalCount,
      audioSegmentWidth: audioCount * 100 / totalCount,
      videoSegmentWidth: videoCount * 100 / totalCount,
    };
  }

  initTooltips() {
    this.$el.find('[data-toggle="tooltip"]').tooltip({
      placement: "bottom",
      trigger: "hover",
      delay: 350,
    });
  }

  destroyTooltips() {
    this.$el.find('[data-toggle="tooltip"]').tooltip("destroy");
  }

  getBaseUrl() {
    return `/search-results/${encodeURIComponent(
      this.model.get("query"),
    )}`;
  }

  onClickGridView() {
    $("#bb-faceted-search-list-view-link").removeClass("hidden");
    $("#bb-faceted-search-grid-view-link").addClass("hidden");

    this.model.set("presentationType", "masonry");
  }

  onClickListView() {
    $("#bb-faceted-search-grid-view-link").removeClass("hidden");
    $("#bb-faceted-search-list-view-link").addClass("hidden");

    this.model.set("presentationType", "list");
  }

  onClickRefineButton() {
    this.trigger("refine");
    return false;
  }

  //onClickModuleSegment() {
  //    this.trigger('includeFacetTerms', '_type', ['MODULE']);
  //}
  //
  //onClickAnthologySegment() {
  //    this.trigger('includeFacetTerms', '_type', ['ANTHOLOGY']);
  //}
  //
  //onClickCollectionSegment() {
  //    this.trigger('includeFacetTerms', '_type', ['COLLECTION']);
  //}

  onClickWrittenSegment() {
    this.trigger("includeFacetTerms", "_f", [
      "BOOK",
      "ARTICLE",
      "OTHER_DOCUMENT",
    ]);
  }

  onClickImageSegment() {
    this.trigger("includeFacetTerms", "_f", ["IMAGE"]);
  }

  onClickAudioSegment() {
    this.trigger("includeFacetTerms", "_f", ["AUDIO"]);
  }

  onClickVideoSegment() {
    this.trigger("includeFacetTerms", "_f", ["VIDEO"]);
  }

  close() {
    this.destroyTooltips();
    super.close();
  }
}

export default FacetedSearchSummaryMenuView;
